import React from "react";

// plugin imports

// style imports
import "./marquee.scss";

// component imports

// svg imports

// component
import {
	motion,
	useScroll,
	useTransform,
	useMotionValue,
	useVelocity,
	useAnimationFrame,
	wrap,
} from "motion/react";

export default function Marquee({ children, baseVelocity = 1, ...delegated }) {
	const baseX = useMotionValue(0);
	const { scrollY } = useScroll();
	const scrollVelocity = useVelocity(scrollY);
	const velocityFactor = useTransform(scrollVelocity, [0, 1000], [0, 5], {
		clamp: false,
	});

	/**
	 * This is a magic wrapping for the length of the text - you
	 * have to replace for wrapping that works for you or dynamically
	 * calculate
	 */
	const x = useTransform(baseX, (v) => `${wrap(-10, -20, v)}%`);

	const directionFactor = React.useRef(-1);
	useAnimationFrame((t, delta) => {
		let moveBy = directionFactor.current * baseVelocity * (delta / 1000);

		/**
		 * This is what changes the direction of the scroll once we
		 * switch scrolling directions.
		 */
		if (velocityFactor.get() < 0) {
			directionFactor.current = 1;
		} else if (velocityFactor.get() > 0) {
			directionFactor.current = -1;
		}

		moveBy -= directionFactor.current * moveBy * velocityFactor.get();

		baseX.set(baseX.get() + moveBy);
	});

	/**
	 * The number of times to repeat the child text should be dynamically calculated
	 * based on the size of the text and viewport. Likewise, the x motion value is
	 * currently wrapped between -20 and -45% - this 25% is derived from the fact
	 * we have four children (100% / 4). This would also want deriving from the
	 * dynamically generated number of children.
	 */
	return (
		<motion.div {...delegated}>
			<div className="marqueeWrapper">
				{children && (
					<motion.div className="marquee" style={{ x }}>
						{[...Array(10)].map((el, i) => (
							<div key={"marqueeEl" + i}>{children}</div>
						))}
					</motion.div>
				)}
			</div>
		</motion.div>
	);
}
